import JChartBarDelta from './Control_Charts'
export { JChartBarDelta }
export default JChartBarDelta